import ApprovePendingApprovalActivity from "./ApprovePendingApprovalActivity";

export default ApprovePendingApprovalActivity;
